import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timer-container" }
const _hoisted_2 = { class: "timer-bar" }
const _hoisted_3 = { class: "timer-text" }

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimerBar',
  props: {
    initialTimeLeft: {},
    totalDuration: {}
  },
  setup(__props: any) {

const props = __props;

const timeLeft = ref(Math.round(props.initialTimeLeft));
let timerId: number | null = null;

const startTimer = () => {
    stopTimer();
    timerId = window.setInterval(() => {
        if (timeLeft.value > 0) {
            timeLeft.value--;
        } else {
            stopTimer();
        }
    }, 1000);
};

const stopTimer = () => {
    if (timerId) {
        clearInterval(timerId);
        timerId = null;
    }
};

watch(() => props.initialTimeLeft, (newTime) => {
    timeLeft.value = Math.round(newTime);
    startTimer();
});

onMounted(startTimer);
onUnmounted(stopTimer);

const formattedTime = computed(() => {
    const minutes = Math.floor(timeLeft.value / 60);
    const seconds = timeLeft.value % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

const progress = computed(() => {
    const duration = props.totalDuration > 0 ? props.totalDuration : 1;
    return (timeLeft.value / duration) * 100;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "timer-bar-inner",
        style: _normalizeStyle({ width: progress.value + '%' })
      }, null, 4)
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(formattedTime.value), 1)
  ]))
}
}

})